<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>
<script setup>
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
let locale = ref(zhCn);
</script>
<style lang="less" cdoped>
body,
html {
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  // filter: grayscale(90%);
}
</style>